export const OnlyAtNykaa = [
  {
    src: "https://images-static.nykaa.com/creatives/7d03a860-f552-42d3-8657-390b6a3d69b9/default.png?tr=w-800,cm-pad_resize",
    h1: "Buy 5 Get 5 + Min 20% Off",
    h3: "On Korean Bestsellers",
  },
  {
    src: "https://images-static.nykaa.com/creatives/8c0d9a97-7c88-4da8-899a-f9546375a175/default.jpg?tr=w-800,cm-pad_resize",
    h1: "Up To 30% Off",
    h3: "Comfy Panties starts at Rs.399",
  },
  {
    src: "https://images-static.nykaa.com/creatives/293fbb88-1a6e-4b3e-aa0d-7e9c5a222625/default.png?tr=w-800,cm-pad_resize",
    h1: "Upto 50% Off + Serum on 799",
    h3: "Best of Fragrances",
  },
  {
    src: "https://images-static.nykaa.com/creatives/132cd70b-778f-4510-ab01-5ae956f7a442/default.jpg?tr=w-800,cm-pad_resize",
    h1: "Upto 50% Off + Serum on 799",
    h3: "Best of Fragrances",
  },
];